import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { DialogActions, DialogContent, DialogTitle } from 'Views/Page/Content/Modal/Components';
import {
  FDBodyText, FDPrimaryActionButton, FDSecondaryActionButton, FDStack,
} from '@facet-wealth/design';
import { ErrorList2 } from 'Components/ComponentLibrary/Molecules/ErrorList2';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';


const Layout = () => {
  const {
    resource, onSubmit, errors, saving,
  } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();

  const onClose = () => {
    clearModalCollection();
  };

  return (
    <>
      <DialogTitle value={'Update address'} />
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <FDStack direction="column" spacing={3}>
          <FDBodyText value={'This should be your primary household mailing address.'} />
          <MetaControlField attr={'line1'} />
          <MetaControlField attr={'line2'} />
          <MetaControlField attr={'line3'} />
          <MetaControlField attr={'city'} />
          <FDStack direction={'row'} spacing={2} wrap>
            <MetaControlField attr={'state'} flex={1} />
            <MetaControlField attr={'postalCode'} flex={1} />
          </FDStack>
          <ErrorList2 title={'Errors updating your address'} errors={errors} />
        </FDStack>
      </DialogContent>
      <DialogActions>
        <FDSecondaryActionButton label={'Cancel'} onClick={onClose} />
        {resource.meta().canPut() ? <FDPrimaryActionButton loading={saving} label={'Save'} onClick={onSubmit} /> : null}
      </DialogActions>
    </>
  );
};

export default Layout;
